import Groups from '../tables/Groups';
import Posts from '../tables/Posts';
import Profiles from '../tables/Profiles';
import ProfilesToGroups from '../tables/ProfilesToGroups';
var groups = new Groups();
var posts = new Posts();
var profiles = new Profiles();
var profilesToGroups = new ProfilesToGroups();
var PostPerformance = {
    alias: 'Post Performance',
    tables: [
        {
            id: groups.id,
            alias: groups.id,
        },
        {
            id: profiles.id,
            alias: profiles.id,
        },
        {
            id: posts.id,
            alias: posts.id,
        },
        {
            id: profilesToGroups.id,
            alias: profilesToGroups.id,
        },
    ],
    joins: [
        {
            left: {
                tableAlias: groups.id,
                columnId: 'group_id',
            },
            right: {
                tableAlias: profilesToGroups.id,
                columnId: 'group_id',
            },
            joinType: 'inner',
        },
        {
            left: {
                tableAlias: profilesToGroups.id,
                columnId: 'customer_profile_id',
            },
            right: {
                tableAlias: profiles.id,
                columnId: 'customer_profile_id',
            },
            joinType: 'inner',
        },
        {
            left: {
                tableAlias: profiles.id,
                columnId: 'customer_profile_id',
            },
            right: {
                tableAlias: posts.id,
                columnId: 'customer_profile_id',
            },
            joinType: 'inner',
        },
    ],
};
export default PostPerformance;
